import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2BulkCustomerAccept = hashCodeCertificate('WaybillV2BulkCustomerAccept')
export default WaybillV2BulkCustomerAccept